// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__6uoFK","note":"styles_note__bIAQc","subtitle":"styles_subtitle__JE2Ya","row":"styles_row__QYDo-"};